export const useAppCheck = () => {
  const { isIos, isAndroid } = useDevice()
  const isPwa = window?.matchMedia('(display-mode: standalone)').matches

  const userAgent = useDevice().userAgent
  const isApp = userAgent.includes('APP_USIMSA')

  // 유저에이전트에서 앱 버전 추출(ex: 2.0.0)
  // 플러터전환 후 APP_USIMSA/2.0.0 형태로 버전 포함됨, 버전 정보 없으면 기존 앱으로 간주(1.4.0)

  const matched = userAgent.match(/APP_USIMSA\/(\d+)\.(\d+)\.(\d+)/)

  const majorVersion = matched ? parseInt(matched[1], 10) : 1
  const minorVersion = matched ? parseInt(matched[2], 10) : 4
  const patchVersion = matched ? parseInt(matched[3], 10) : 0

  const appVersion = matched ? `${majorVersion}.${minorVersion}.${patchVersion}` : '1.4.0'

  // 전화기능이 탑재된 버전은 IOS(2.1.x) AOS(1.1.x)이상부터 지원
  const isCallSupportedAppVersion = () => {
    if (!isApp) return false
    if (!matched) return false

    const major = parseInt(matched[1], 10)
    const minor = parseInt(matched[2], 10)

    if (isIos) {
      return major > 2 || (major === 2 && minor >= 1)
    }

    if (isAndroid) {
      return major > 2 || (major === 2 && minor >= 2)
    }

    return false
  }

  return {
    isPwa,
    isApp,
    userAgent,
    majorVersion,
    appVersion,
    isCallSupportedAppVersion
  }
}
